import styled from "styled-components";
import * as Variables from "../../globalStyles/Variables";
import { Link } from "react-router-dom";
import { Separator, SubTitle } from "../../globalStyles/CommonStyles";
import { useRecoilValue } from "recoil";
import { benefitsFetched } from "../../recoil/Selectors";
import { benefitType } from "../../utils/types";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../firebase.config";
import { motion } from "framer-motion";


const Container = styled.div`

  @media ${Variables.device.tablet}{
    margin-top: 32px;
  }
`;

const Slider = styled(motion.div)`
  display: grid;
  max-width: 100vw;
  overflow: auto;
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  gap: 16px;
  margin: 0 -12px;
  padding: 0 12px;

  @media ${Variables.device.tablet}
  {
    grid-template-columns: 1fr 1fr;
    grid-auto-flow: initial;
  }
`

const Content = styled.div`
    color: ${Variables.getColor().textColor};
    z-index: 1;
    height: 100%;
    padding: 16px;
    display: grid;
    gap: 8px;
    grid-template-rows: auto 1fr auto;
`;

const TitleItem = styled.h2`

    align-self: flex-start;
    color:${Variables.getColor().textColor}d6;

    text-transform: uppercase;
    line-height: 120%;
    font-size: 2.6rem;

`;

const Description = styled.p`
    z-index: 1;
    font-size: 1.4rem;
`;
const Notes = styled.p`
    z-index: 1;
    font-size: 1.2rem;
`;

const Item = styled(Link)`

  background-color: ${Variables.getColor().background};
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  justify-content: space-between;
  aspect-ratio: 16/9;
  height: 186px;
  width: auto;

  @media ${Variables.device.tablet}{
width: 100%;
  }
  
`;

const Background = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
`;

const Gradient = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
  background: ${(props) => props.color ? `linear-gradient(90deg, ${props.color} 0%, ${props.color}00 100%)` : "red"};
`;


const ItemRecommended = ({ item }: { item: benefitType }) => { 
  return (
    <Item onClick={() => logEvent(analytics, "select_promotion", { "product": item.slug })} key={item.slug} to={item.product ? `product/${item.product}` : ""}>
      <Gradient color={item.color} />
      <Background src={item.imageUrl} alt={item.title} loading="lazy" title={item.title} />
      <Content>
        <TitleItem>{item.title}</TitleItem>
        <Description>{item.description}</Description>
        <Notes>{item.notes}</Notes>
      </Content>
    </Item>)
}

const Benefits = () => {

  const benefits = useRecoilValue<benefitType[]>(benefitsFetched);

  if (benefits && benefits?.length > 0) {
    return (
      <>
        <Container>
          <SubTitle>Beneficios Especiales</SubTitle>
          <Slider>
            {benefits?.map((item) => {
              return <ItemRecommended key={`reco-${item.slug}`} item={item} />;
            })}
          </Slider>
        </Container>
        <Separator />
      </>

    );
  }
  else {
    return null
  }
};

export default Benefits;
